module.exports = __webpack_public_path__ + "static/media/12.960c9661.jpg";